//doent return an error if the id doesnt exist, instead returns an empty function
const currentUrl = location.href;

Document.prototype.querySelectorSafe = function (selector) {
	let element = this.querySelector(selector);
	if (!element) {
		console.error('Element with selector ' + selector + ' does not exist.');
		return new Proxy({}, {
			get: function (target, property) {
				return function () { };
			}
		});
	}
	return element;
}

Document.prototype.getElementByIdSafe = function (id) {
	let element = this.getElementById(id);
	if (!element) {
		console.error('Element with id ' + id + ' does not exist.');
		return new Proxy({}, {
			get: function (target, property) {
				return function () { };
			}
		});
	}
	return element;
}

jQuery(document).ready(function($){
    $(".offcanvas .menu li.menu-item-has-children .nav-arrow").on("click", function(e){
        e.stopPropagation();
        var parentLi = $(this).closest("li.menu-item-has-children");
        parentLi.toggleClass("active");
        if (parentLi.hasClass("active")) {
            parentLi.find('.sub-menu').first().slideDown().siblings('.sub-menu').slideDown();
        } else {
            parentLi.find('.sub-menu').slideUp().siblings('.sub-menu').slideUp();
        }
        return false;
    });

    const filterDropDown = $('.search-btn-dropdown');
    filterDropDown.on('click', function(e) {
        const dropdownMenu = $(this).siblings('.filterDropdown');
        if( $(this).hasClass('active') ) {
            $(this).removeClass('active');
            $(this).find('.search-icon').removeClass('d-none').addClass('d-inline-block');
            $(this).find('.x-icon').addClass('d-none').removeClass('d-inline-block');
            dropdownMenu.slideUp(200);
        } else {
            $(this).addClass('active');
            $(this).find('.search-icon').addClass('d-none').removeClass('d-inline-block');
            $(this).find('.x-icon').removeClass('d-none').addClass('d-inline-block');
            dropdownMenu.slideDown(300);
        }
    });
});

adjustContentSpacing();
window.addEventListener("resize", () => {
    adjustContentSpacing();
});

function adjustContentSpacing()
{
    const headerHeight = document.querySelector('#header').offsetHeight;
    const mainContent = document.querySelector('#mainContent');
    const mobileMenu = document.querySelector('#mobileMenu');
    mainContent.style.paddingTop = `${headerHeight + 1 }px`;
    // mobileMenu.style.marginTop = `${headerHeight + 1 }px`;
}

function sliderAutoplay(slider, duration) {
    duration = duration || 2000
    let timeout
    let mouseOver = false
    function clearNextTimeout() {
        clearTimeout(timeout)
    }
    function nextTimeout() {
        clearTimeout(timeout)
        if (mouseOver) return
            timeout = setTimeout(() => {
            slider.next()
        }, duration)
    }
    slider.on("created", () => {
        slider.container.addEventListener("mouseover", () => {
            mouseOver = true
            clearNextTimeout()
        })
        slider.container.addEventListener("mouseout", () => {
            mouseOver = false
            nextTimeout()
        })
        nextTimeout()
    })
    slider.on("dragStarted", clearNextTimeout)
    slider.on("animationEnded", nextTimeout)
    slider.on("updated", nextTimeout)
}

function sliderNavigation(slider, navClasses, dotsClasses) {
    navClasses = navClasses || [];
    dotsClasses = dotsClasses || ["d-flex", "mt-4", "pt-2", "justify-content-start"];
    let wrapper, dots, arrowLeft, arrowRight

    function removeActive() {
        slider.slides.forEach((slide) => {
            slide.classList.remove("active")
        })
    }

    function addActive(idx) {
        slider.slides[idx].classList.add("active")
    }

    function markup(remove) {
        wrapperMarkup(remove)
        dotMarkup(remove)
        arrowMarkup(remove)
    }

    function removeElement(elment) {
        elment.parentNode.removeChild(elment)
    }

    function createDiv(className) {
        var div = document.createElement("div")
        var classNames = className.split(" ")
        classNames.forEach((name) => div.classList.add(name))
        return div
    }

    function arrowMarkup(remove) {
        if (remove) {
            removeElement(arrowLeft)
            removeElement(arrowRight)
            return
        }
        // create right arrow
        arrowLeft = createDiv("arrow arrow--left")
        // add html to arrow
        arrowLeft.innerHTML = `<svg width="14" height="26" viewBox="0 0 14 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.7071 0.292893C13.3166 -0.0976311 12.6834 -0.0976311 12.2929 0.292893L0.292893 12.2929C-0.0976315 12.6834 -0.0976315 13.3166 0.292893 13.7071L12.2929 25.7071C12.6834 26.0976 13.3166 26.0976 13.7071 25.7071C14.0976 25.3166 14.0976 24.6834 13.7071 24.2929L2.41421 13L13.7071 1.70711C14.0976 1.31658 14.0976 0.683417 13.7071 0.292893Z" fill="#3C3B70"/></svg>`;
        // add attribute
        arrowLeft.setAttribute("role", "button")
        // add style to arrow
        arrowLeft.style.cssText = `top: 40%; left: -38px;`;
        // add class to left arrow
        arrowLeft.classList.add(...["d-inline-block", "position-absolute"], ...navClasses)
        arrowLeft.addEventListener("click", () => slider.prev())

        // create right arrow
        arrowRight = createDiv("arrow arrow--right")
        // add html to arrow
        arrowRight.innerHTML = `<svg width="14" height="26" viewBox="0 0 14 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L13.7071 12.2929C14.0976 12.6834 14.0976 13.3166 13.7071 13.7071L1.70711 25.7071C1.31658 26.0976 0.683417 26.0976 0.292893 25.7071C-0.0976311 25.3166 -0.0976311 24.6834 0.292893 24.2929L11.5858 13L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z" fill="#3C3B70"/></svg>`;
        // add attribute
        arrowRight.setAttribute("role", "button")
        // add style to arrow
        arrowRight.style.cssText = `top: 40%; right: -38px;`;
        // add class to left arrow
        arrowRight.classList.add(...["d-inline-block", "position-absolute"], ...navClasses)
        arrowRight.addEventListener("click", () => slider.next())

        wrapper.appendChild(arrowLeft)
        wrapper.appendChild(arrowRight)
    }

    function wrapperMarkup(remove) {
        if (remove) {
            var parent = wrapper.parentNode
            while (wrapper.firstChild)
            parent.insertBefore(wrapper.firstChild, wrapper)
            removeElement(wrapper)
            return
        }
        wrapper = createDiv("navigation-wrapper")
        // add class to wrapper
        wrapper.classList.add(...["position-relative"])
        slider.container.parentNode.appendChild(wrapper)
        wrapper.appendChild(slider.container)
    }

    function dotMarkup(remove) {
        if (remove) {
            removeElement(dots)
            return
        }
        dots = createDiv("dots")
        //   add class to dots
        dots.classList.add(...[...dotsClasses])
        slider.track.details.slides.forEach((_e, idx) => {

            var dotParent = createDiv("dot-parent");
            var dot = createDiv("dot")
            // add class to dot
            // add style to dot
            // if( dotsClasses.includes("product-slider-navigation") ) {
            //     dotParent.classList.add('w-100')
            //     dot.style.background = "rgba(159, 159, 159, 0.3)"
            //     dot.style.borderRadius = "0"
            //     dot.style.height = "2px"
            //     dot.style.width = "100%"
            // }
            dot.setAttribute("role", "button") // add attribute
            dot.addEventListener("click", () => slider.moveToIdx(idx))
            dotParent.appendChild(dot);
            dots.appendChild(dotParent)
        })
        wrapper.appendChild(dots)
    }

    function updateClasses() {
        var slide = slider.track.details.rel
        slide === 0
            ? arrowLeft.classList.add("arrow--disabled")
            : arrowLeft.classList.remove("arrow--disabled")
        slide === slider.track.details.slides.length - 1
            ? arrowRight.classList.add("arrow--disabled")
            : arrowRight.classList.remove("arrow--disabled")
            Array.from(dots.children).forEach(function (dotP, idx) {
                var dot = dotP.children[0];
                if(idx === slide){
                    dot.classList.add("dot--active")
                    // if( dotsClasses.includes("product-slider-navigation") ) {
                    //     dot.classList.add("bg-white")
                    // }
                } else {
                    dot.classList.remove("dot--active")
                    // if( dotsClasses.includes("product-slider-navigation") ) {
                    //     dot.classList.remove("bg-white")
                    // }
                }
            })
    }

    slider.on("created", () => {
        addActive(slider.track.details.rel)
        markup()
        updateClasses()
    })
    slider.on("optionsChanged", () => {
        markup(true)
        markup()
        updateClasses()
    })
    slider.on("slideChanged", () => {
        removeActive()
        addActive(slider.track.details.rel)
        updateClasses()
    })
    slider.on("destroyed", () => {
        markup(true)
    })
}

function sliderAdaptiveHeight(slider) {
    function updateHeight() {
        slider.container.style.height = slider.slides[slider.track.details.rel].offsetHeight + "px";
    }

    slider.on("created", updateHeight)
    slider.on("slideChanged", updateHeight)
}

if ( typeof LocomotiveScroll === 'undefined' ) {
    headerAnimate();
}

function headerAnimate() {
    window.addEventListener('scroll', function(e) {
        var distanceY = window.pageYOffset || document.documentElement.scrollTop;
        var shrinkOn = 200;
        var header = document.getElementById('header');
        if ( distanceY >= shrinkOn ) {
            header.classList.add('pinned');
        } else {
            header.classList.remove('pinned');
        }
    });
}

let switcherLabel = document.querySelectorAll('.toggleLanguage');
switcherLabel.forEach(function (item) {
    item.addEventListener("click", function (event) {
        let languageCollection = event.currentTarget.parentNode.querySelector('.language-collection');
        languageCollection.classList.toggle('active');
        if ( typeof LocomotiveScroll !== 'undefined' ) {
            if (languageCollection.classList.contains('active')) {
                locoScroll.stop();
            } else {
                locoScroll.start();
            }
        }
    });
});


var sliderKeenContainer = document.getElementById("sliderKeen");
if( sliderKeenContainer ) {
    var sliderKeen = new KeenSlider("#sliderKeen", {
        loop: true,
        breakpoints: {
            "(min-width: 320px)": {
                slides: { origin: "center", perView: 1, spacing: 20 },
            },
        }
    }, [
        slider => {
            sliderAutoplay(slider, 3000)
            sliderNavigation(slider, ['d-none'], ['d-none','d-lg-flex','mt-4','justify-content-center', 'flex-nowrap']);
            const prev = document.querySelectorAll('.keen-prev')

            prev.forEach((item) => {
                item.onclick = (e) => {
                    e.preventDefault()

                    slider.prev()
                }
            });

            const next = document.querySelectorAll('.keen-next')

            next.forEach((item) => {
                item.onclick = (e) => {
                    e.preventDefault()

                    slider.next()
                }
            });
        }
    ])
}

var sliderKeenContainerMobile = document.getElementById("sliderKeenMobile");
if( sliderKeenContainerMobile ) {
    var sliderKeen = new KeenSlider("#sliderKeenMobile", {
        loop: true,
        breakpoints: {
            "(min-width: 320px)": {
                slides: { origin: "center", perView: 1, spacing: 20 },
            },
        }
    }, [
        slider => {
            sliderAutoplay(slider, 3000)
            sliderNavigation(slider, ['d-none'], ['d-flex','d-lg-none','mt-4','justify-content-center', 'flex-nowrap']);
            const prev = document.querySelectorAll('.keen-prev')

            prev.forEach((item) => {
                item.onclick = (e) => {
                    e.preventDefault()

                    slider.prev()
                }
            });

            const next = document.querySelectorAll('.keen-next')

            next.forEach((item) => {
                item.onclick = (e) => {
                    e.preventDefault()

                    slider.next()
                }
            });
        }
    ])
}


// const videoContainer = document.getElementById("video-wrapper");
// lightGallery(videoContainer, {
//     plugins: [lgVideo],
//     videojs: true,
// });

document.getElementById('playButton').addEventListener('click', function() {
    var video = document.getElementById('bgvid');
    video.play();
});

document.getElementById('bgvid').addEventListener('play', function() {
    var videoWrapper = document.getElementById('video-wrapper');
    videoWrapper.classList.add('playing');
});

document.getElementById('bgvid').addEventListener('pause', function() {
    var videoWrapper = document.getElementById('video-wrapper');
    videoWrapper.classList.remove('playing');
});

document.getElementById('bgvid').addEventListener('ended', function() {
    var videoWrapper = document.getElementById('video-wrapper');
    videoWrapper.classList.remove('playing');
});

const galleryWrapper = document.querySelectorAll(".gallery-lightbox");
if( galleryWrapper ) {
    galleryWrapper.forEach(function (item) {
        lightGallery(item, {
            // plugins: [lgThumbnail],
            // thumbnail: true,
            toggleThumb: true,
        });
    });
}

var sliderKeenContainer = document.querySelectorAll(".productSlider");
if( sliderKeenContainer ) {
    sliderKeenContainer.forEach(function (item) {
        var sliderKeen = new KeenSlider(item, {
            loop: true,
            breakpoints: {
                "(min-width: 320px)": {
                    slides: { perView: 1.4, spacing: 30 },
                },
                "(min-width: 992px)": {
                    slides: { perView: 2, spacing: 30 },
                },
            }
        }, [
            slider => {
                sliderAutoplay(slider, 3000)
                sliderNavigation(slider, ['d-none'], ['d-flex','mt-4','justify-content-start', 'product-slider-navigation']);
                const prev = document.querySelectorAll('.keen-prev')
                prev.forEach((item) => {
                    item.onclick = (e) => {
                        e.preventDefault()

                        slider.prev()
                    }
                });
                const next = document.querySelectorAll('.keen-next')
                next.forEach((item) => {
                    item.onclick = (e) => {
                        e.preventDefault()
                        slider.next()
                    }
                });
            }
        ])
    });
}

var gallerySlider = document.getElementById("gallerySlider");
if( gallerySlider ) {
    var sliderKeen = new KeenSlider(gallerySlider, {
        loop: true,
        breakpoints: {
            "(min-width: 320px)": {
                slides: { perView: 1, spacing: 0 },
            },
            "(min-width: 992px)": {
                slides: { perView: 3, spacing: 20 },
            },
        }
    }, [
        slider => {
            // sliderAutoplay(slider, 3000)
            sliderNavigation(slider, ['d-none'], ['d-flex','d-lg-none','mt-4','justify-content-center', 'product-slider-navigation']);
            const prev = document.querySelectorAll('.keen-prev')
            prev.forEach((item) => {
                item.onclick = (e) => {
                    e.preventDefault()

                    slider.prev()
                }
            });
            const next = document.querySelectorAll('.keen-next')
            next.forEach((item) => {
                item.onclick = (e) => {
                    e.preventDefault()
                    slider.next()
                }
            });
        }
    ])
}

var wawGallery = document.getElementById("wawGallery");
if( wawGallery ) {
    var sliderKeen = new KeenSlider(wawGallery, {
        loop: true,
        breakpoints: {
            "(min-width: 320px)": {
                slides: { perView: 1, spacing: 30 },
            },
            "(min-width: 992px)": {
                slides: { perView: 1, spacing: 20 },
            },
        }
    }, [
        slider => {
            sliderAutoplay(slider, 3000)
            sliderNavigation(slider, ['d-none'], ['d-flex','justify-content-center']);
            const prev = document.querySelectorAll('.keen-prev')
            prev.forEach((item) => {
                item.onclick = (e) => {
                    e.preventDefault()

                    slider.prev()
                }
            });
            const next = document.querySelectorAll('.keen-next')
            next.forEach((item) => {
                item.onclick = (e) => {
                    e.preventDefault()
                    slider.next()
                }
            });
        }
    ])
}

var pledgeSlider = document.getElementById("pledgeSlider");
if( pledgeSlider ) {
    var sliderKeen = new KeenSlider(pledgeSlider, {
        loop: true,
        breakpoints: {
            "(min-width: 320px)": {
                slides: { perView: 2.3, spacing: 30 },
            },
            "(min-width: 768px)": {
                slides: { perView: 4.3, spacing: 30 },
            },
        }
    }, [
        slider => {
            sliderAutoplay(slider, 3000)
            sliderNavigation(slider, ['d-none'], ['d-flex','justify-content-center']);
            const prev = document.querySelectorAll('.keen-prev')
            prev.forEach((item) => {
                item.onclick = (e) => {
                    e.preventDefault()

                    slider.prev()
                }
            });
            const next = document.querySelectorAll('.keen-next')
            next.forEach((item) => {
                item.onclick = (e) => {
                    e.preventDefault()
                    slider.next()
                }
            });
        }
    ])
}

// const desktopMenu = document.getElementById('desktopMenu');
// const mobileMenu = document.getElementById('mobileMenu');
// // const menuToggle = document.querySelectorAll('.toggle');
// function toggleActiveClass() {
//     const toggleElements = document.querySelectorAll('.toggle');
//     toggleElements.forEach((toggleElement) => {
//         toggleElement.classList.toggle('active');
//     });
// }

// if( desktopMenu || mobileMenu ) {
//     desktopMenu.addEventListener('click', toggleActiveClass);
//     desktopMenu.addEventListener('hidden.bs.offcanvas', toggleActiveClass);
//     mobileMenu.addEventListener('hidden.bs.offcanvas', toggleActiveClass);
// }

// desktopMenu.forEach((menu) => {
//     menu.addEventListener('click', toggleActiveClass);
// });

function setBackBtn() {
    if (document.querySelector('#step-2-container').classList.contains('active') ||
        document.querySelector('#step-3-container').classList.contains('active') ||
        document.querySelector('#step-4-container').classList.contains('active') ||
        document.querySelector('#step-5-container').classList.contains('active')
    ) {
        document.querySelector('#back-btns').classList.remove('d-none');
    }
}
document.addEventListener('ajaxComplete', function() {
    setBackBtn();
});

// document.addEventListener('DOMContentLoaded', () => {
//     const sections = document.querySelectorAll('section[data-title]');
//     const menuItems = document.querySelectorAll('.menu .menu-item a[title]');
//     let activeSection = null;

//     // Function to add class to menu item
//     function highlightMenuItem(sectionTitle) {
//         menuItems.forEach(menuItem => {
//             const menuItemTitle = menuItem.getAttribute('title');
//             if (sectionTitle === menuItemTitle) {
//                 menuItem.classList.add('active');
//             } else {
//                 menuItem.classList.remove('active');
//             }
//         });
//     }

//     // IntersectionObserver callback
//     const observerCallback = (entries) => {
//         entries.forEach(entry => {
//             if (entry.isIntersecting) {
//                 const sectionTitle = entry.target.getAttribute('data-title');
//                 if (sectionTitle !== activeSection) {
//                     activeSection = sectionTitle;
//                     highlightMenuItem(sectionTitle);
//                 }
//             }
//         });
//     };

//     // Create an IntersectionObserver
//     const observerOptions = {
//         root: null, // Observe changes relative to the viewport
//         threshold: 0.7 // Trigger callback when at least 70% of the section is in view
//     };

//     const observer = new IntersectionObserver(observerCallback, observerOptions);

//     // Observe each section
//     sections.forEach(section => {
//         observer.observe(section);
//     });
// });

jQuery(document).ready(function($) {
    const header = $('#header');
    const headerHeight = header.length ? header.outerHeight() : 0;

    $('.menu .menu-item a[title]').on('click', function(event) {
        event.preventDefault();
        const title = $(this).attr('title');
        const targetSection = $(`section[data-title="${title}"]`);

        if (targetSection.length) {
            const targetPosition = targetSection.offset().top - headerHeight - 30;
            $('html, body').animate({
                scrollTop: targetPosition
            }, 500); // Duration of animation in milliseconds
            setTimeout(() => {
                $('.menu .menu-item a').removeClass('active');
                $(this).addClass('active');
            }, 500);
        } else {
            console.error(`Target section with data-title="${title}" not found.`);
        }
    });
});
